import React, { useEffect } from "react";
import lottie from "lottie-web";
import "./Dashboard.css";
import homepage from "./grolog-homepage.json";

const LottieControl = () => {
  useEffect(() => {
    lottie.loadAnimation({
      container: document.querySelector("#homepage-animation"),
      animationData: homepage,
    });
  }, []);

  return <div id="homepage-animation" className="bubbleBottom" />;
};

export default LottieControl;
